import { css, html } from 'lit';

import { nothing } from 'lit-html';

import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from "../../features/base-component/base-component";
import { messageTemplates } from "../../common/constants/api-constants";
import { MessageType } from "./global-message.interface";
import emit from "../../common/events";
import { getMessageIcon } from './alert.util';
import { booleanConverter } from "../../common/converters";
import { ifDefined } from "lit-html/directives/if-defined.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

export enum AlertSize {
  normal = 'normal',
  small = 'small'
}

@customElement('mhecomm-alert')
export class Alert extends BaseComponent {
  static styles = [css`
    .alert-dismissible .btn-close.small {
      padding-top: .825rem;
      padding-bottom: .825rem;
    }
  `];


  @property()
  message = '';

  @property()
  type: MessageType = MessageType.info;

  @property()
  size = AlertSize.normal;

  @property({type: Boolean})
  dismissible = false;

  @property({converter: booleanConverter})
  hideIcon = false;

  private bsAlert?: Alert;

  renderComp() {
    const icon = getMessageIcon(this.type);
    const messageTemplate = messageTemplates[this.message];
    return html`
      ${this.type !== MessageType.none ? html`
        <div
          class="alert alert-${this.type} ${this.dismissible ? 'alert-dismissible fade show' : ''} d-flex align-items-top ${this.size === AlertSize.small ? 'py-2 ps-2' : ''}"
          role="${ifDefined(this.type === 'danger' ? "alert" : undefined)}"
          aria-live="${ifDefined(this.type === 'danger' ? "assertive" : undefined)}"
          aria-relevant="${ifDefined(this.type === 'danger' ? "all" : undefined)}"
          aria-atomic="${ifDefined(this.type === 'danger' ? "true" : undefined)}"
          >
          ${!this.hideIcon && icon ? html`
            <uxt-icon icon=${icon} class="me-3"></uxt-icon>` : ''}
          ${messageTemplate ?
            messageTemplate :
            html`${this.type === 'danger' ? html`<span class="visually-hidden">Error&nbsp;</span>` : nothing}
            <span class="mb-0">
              ${unsafeHTML(this.message)}
            </span>`
          } ${this.dismissible && this.type !== 'danger' ? html`
            <button
              type="button"
              @click=${this.close}
              class="btn-close ${this.size}"
              aria-label="Close">
            </button>
          ` : nothing}
        </div>
      ` : nothing}
    `;
  }

  protected updated(_changedProperties: Map<string | number | symbol, unknown>): void {
    this.bsAlert = this.bsInit('.alert', window.bootstrap?.Alert)?.instance;
    if (
      _changedProperties.has('message') &&
      this.message &&
      this.type === MessageType.danger &&
      !window.location.origin.includes('local') &&
      !window.location.pathname.includes('ecomm-ui-docs')
    ) {
      this.scrollTo();
    }
  }

  close() {
    emit({
      element: this,
      name: 'alert-close',
      detail: {
        message: this.message,
        type: this.type,
        size: this.size
      }
    });

    if (this.bsAlert) {
      this.bsAlert.close();
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-alert': Alert;
  }
}
